import React, { useEffect } from "react";
import Dashboard from "../components/Dashboard/dashboard";

const AdminPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Dashboard />
    </div>
  );
};

export default AdminPage;
